module.exports = __webpack_public_path__ + "static/media/31JFA10.6945d4e0.jpg";